import AvailabilityZone from "enums/AvailabilityZone";
import Host from "enums/Host";
import { regions } from "@genesys/cloud-frontend/api-base";

/**
 * @param  {string} host hostname to use for lookup
 * @returns {string} preferred availability zone given provided host
 */
export const azForHost = (host) => {
    switch (host) {
        case Host.COM:
            return AvailabilityZone.US_EAST_1;
        case Host.AU:
            return AvailabilityZone.AP_SOUTH_EAST_2;
        case Host.IE:
            return AvailabilityZone.EU_WEST_1;
        case Host.JP:
            return AvailabilityZone.AP_NORTH_EAST_1;
        case Host.DE:
            return AvailabilityZone.EU_CENTRAL_1;
        default:
            return AvailabilityZone.US_EAST_1;
    }
};

const devRegions = [
    regions.dev,
    "localhost:8002",
    "localhost:4300",
    "localhost:8090",
];

const nonProdRegions = [...devRegions, regions.test];
export const isNonProdRegion = () => {
    const { origin } = window.location;
    return nonProdRegions.some((region) => origin.endsWith(region));
};

export const getCurrentRegion = () => {
    const { origin } = window.location;
    const regionValues = Object.values(regions);
    return devRegions.some((region) => origin.endsWith(region))
        ? regions.dev
        : regionValues.find((region) => origin.endsWith(region));
};
